import { getPersonalDetails } from '../services/vu'

export const fetchPersonalDataIfNeeded = () => {
  return (dispatch, getState) => {
    if (shouldFetchPersonalDetails(getState())) {
      return dispatch(fetchPersonalDetails())
    }
    return Promise.resolve()
  }
}

const shouldFetchPersonalDetails = state => {
  return !state.personalDetails.data
}

export const fetchPersonalDetails = () => {
  return dispatch => {
    dispatch(requestPersonalDetails())

    return getPersonalDetails().then((personalDetails = {}) => {
      return dispatch(receivePersonalDetails(personalDetails))
    })
  }
}

const requestPersonalDetails = () => {
  return {
    type: 'REQUEST_PERSONAL_DETAILS'
  }
}

export const receivePersonalDetails = (personalDetails = {}) => {
  return {
    type: 'RECEIVE_PERSONAL_DETAILS',
    personalDetails
  }
}
